<template>
  <RouterView @page="$emit('page', $event)" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    payeeId: String,
  },
  computed: {
    ...mapGetters(['permissions', 'payeeAdmin']),
    hasMessagePermissions() {
      return this.permissions?.some((x) => x.type === 'MessageAdmin' && x.scope?.payeeId === this.payeeId)
      || this.payeeAdmin;
    },
  },
  methods: {
    ...mapActions([
      'getPayee',
      'getPayersGroups',
      'getPayersProperties',
      'getCurrencies',
      'getUnreadMessages',
      'getUnreadNews',
      'getUserPermissions',
    ]),
    loopMessageRequest() {
      if (this.destroyed) return;
      if (process.env.NODE_ENV === 'development') return;

      if (this.hasMessagePermissions) {
        this.getUnreadMessages();
      }
      this.getUnreadNews();

      this.timeout = setTimeout(() => {
        this.loopMessageRequest();
      }, 20 * 1000);
    },
  },
  created() {
    this.$store.commit('setPayeeId', this.payeeId);

    this.getPayee({
      params: {
        payeeId: this.payeeId,
      },
    });

    this.getUserPermissions();
    this.getPayersGroups();
    this.getPayersProperties();
    this.getCurrencies();
    this.getUnreadNews();
    this.loopMessageRequest();
  },
  destroyed() {
    this.destroyed = true;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};
</script>
